import React from 'react';
import { AiOutlineInstagram } from "react-icons/ai";
import { BiLogoLinkedin } from "react-icons/bi";
import { RiFacebookFill } from "react-icons/ri";
import { BiLogoTiktok } from "react-icons/bi";
import { BsInstagram } from "react-icons/bs";
import { FaLinkedinIn, FaTiktok } from "react-icons/fa";
import { LOCALES } from "./constants";

// In Jest environment, use process.env, in Vite use import.meta
const imageUrl = import.meta.env.VITE_API_IMAGE_URL;
export const blobURL = imageUrl || '';

// ---------------------------------Articles-------------------------------------
export const otherCost = "93";
export const HourlyWages = "92";
export const InvoiveAsDescribedBellow = "2";
export const costPerDay = "94";
export const costPerWeek = "95";
export const costPerMonth = "96";
export const costAgreement = "97";

 export const articlesNumber = {
    HourlyWages: '92',
    otherCost: '93',
    ExpenditureAccordingToTheAttachedPDF: '2',
    costPerDay: '94',
    costPerWeek: '95',
    costPerMonth: '96',
    costAgreement: '97',
  };

export const englishTranslations = {
    'Betalning per timme': 'Payment Per Hour',
    'Betalning per dag': 'Payment Per Day',
    'Betalning per vecka': 'Payment Per Week',
    'Betalning per månad': 'Payment Per Month',
    'Betalning enligt överenskommelse': 'Payment As Agreed',
    'Tim': 'hours',
    'Dag': "day",
    "Vecka":"week",
    "m":"month",
    "a":"agreed",
    "h":"hours",
    "d":"day",
    "w":"week",
  };

export const otherArticleOptions = [
  {
    id: 1,
    label: "Mileage Report",
    key: "mileage",
  },
  {
    id: 2,
    label: "Travel Expenses as per attached PDF",
    key: "travel",
  },
  {
    id: 3,
    label: "Expenses for materials and tools as per attached PDF",
    key: "material_vat",
  },
  {
    id: 4,
    label: "Allowance outside Sweden",
    key: "allowance_out",
  },
  {
    id: 5,
    label: "Allowance in Sweden",
    key: "allowance_in",
  },
];

export const featuresData = [
  {
    title: "SEND COMBINED INVOICE",
    id: 1,
    description:
      "Bill together with other freelancers working for the same client. Invite the freelancers to the platform and we will pay your salary separately!",
    image: `${blobURL}/invoice1.png`,
  },
  {
    title: "ALLOCATE HOLIDAY COMPENSATION",
    id: 2,
    description:
      "In our invoicing tool, you can set aside between 0-50% of your income in holiday compensation.",
    image: `${blobURL}/invoice3.png`,
  },
  {
    title: "EXPRESS PAYMENT",
    id: 3,
    description:
      "Use our express payment if you want your money paid out within two days!",
    image: `${blobURL}/invoice3.png`,
  },
  {
    title: "INVOICING IN DIFFERENT CURRENCIES",
    id: 4,
    description:
      "We offer invoicing in various currencies, Swedish kronor (SEK), US dollars (USD), Euros (EUR), British pounds (GBP), Swiss Franc (CHF), Canadian Dollar (CAD), Australian Dollar (AUD), Norwegian Krone (NOK), Danish Krone (DKK),Japanese Yen (JPY) and Chinese Yuan (CNY).",
    image: `${blobURL}/invoice5.png`,
  },
  {
    title: "WRITE AGREEMENTS AND CREATE OFFERS",
    id: 6,
    description:
      "With Invozio, you can easily create and adapt agreements and quotes using our professional templates.",
    image: `${blobURL}/invoice1.png`,
  },
  {
    title: "PRELIMINARY INVOICES",
    id: 7,
    description:
      "With our feature, you can easily send a preliminary invoice to your client for approval before finalizing the actual invoice.",
    image: `${blobURL}/invoice6.png`,
  },
  {
    title: "TIME REPORTING AND REGISTERING EXPENDITURE",
    id: 8,
    description:
      "We offer you a simple and flexible solution to be able to report your hours and register your expenses",
    image: `${blobURL}/invoice6.png`,
  },

  {
    title: "CHANGE THE VAT RATE",
    id: 10,
    description:
      "In our invoicing tool, you can easily choose between different VAT rates, including 0%, 6%, 12% and 25%. This means that you can adapt the VAT rate according to the rules and requirements that apply to your particular service or product.",
    image: `${blobURL}/invoice4.png`,
  },
  {
    title: "GET SALARY PAID TO A FOREIGN BANK ACCOUNT",
    id: 11,
    description:
      "With Invozio, you can have your salary paid to a foreign bank account that has an IBAN number. A fee may be added depending on the bank and country.",
    image: `${blobURL}/invoice6.png`,
  },

  {
    title: "INVOICING WITH ROT AND RUT DEDUCTION",
    id: 12,
    description:
      "The possibility of using RUT/ROT-which enables the private customer to receive up to 50% deduction for the work performed. Does not apply if you are invoicing a company.",
    image: `${blobURL}/invoice6.png`,
  },
   {
    title: "GET PAID FASTER WITH REVOLUT",
    id: 13,
    description:
      "Enjoy quicker salary payments when you link a Revolut account. Don’t have one? Sign up here and start benefiting today.",
    image: `${blobURL}/invoice6.png`,
  },
];

export const socialIcons = {
  title: "Official channels",
  links: [
    {
      isLink: true,
      link: "https://www.facebook.com/Invozio",
      icon: <RiFacebookFill className="social-icon" />,
      iconWithoutClass: <RiFacebookFill />,
      iconWithRightSidebarClass: (
        <RiFacebookFill
          className="social-icon border-primary border"
          size={10}
        />
      ),
      ariaLabel: "Visit our Facebook page",
    },

    {
      isLink: true,
      link: "https://www.linkedin.com/company/invozio/?viewAsMember=true",
      icon: <BiLogoLinkedin className="social-icon" />,
      iconWithoutClass: <BiLogoLinkedin />,
      iconWithRightSidebarClass: (
        <FaLinkedinIn className="social-icon border-primary border" />
      ),
      ariaLabel: "Visit our LinkedIn page",
    },

    {
      isLink: true,
      link: "https://www.instagram.com/invozio/?igshid=YmMyMTA2M2Y%3D",
      icon: <AiOutlineInstagram className="social-icon" />,
      iconWithoutClass: <AiOutlineInstagram />,
      iconWithRightSidebarClass: (
        <BsInstagram className="social-icon border-primary border" />
      ),
      ariaLabel: "Visit our Instagram page",
    },

    {
      isLink: true,
      link: `https://www.tiktok.com/@invozio?lang=${LOCALES.SV_SE}`,
      icon: <BiLogoTiktok className="social-icon" />,
      iconWithoutClass: <BiLogoTiktok />,
      iconWithRightSidebarClass: (
        <FaTiktok className="social-icon border-primary border" />
      ),
      ariaLabel: "Visit our Tiktok page",
    },
  ],
};

// Employee certificate
export const empCertificateLeft = [
  {
    title: "1 Personal data",
    description:
      "Enter the employee's surname, first name and social security number.",
  },
  {
    title: "2 Details of the employment",
    description:
      "Duration of employment: Enter the dates between which the employment lasted. Write the first and last day of employment. About this employment preceded by a previous employment, the employments must not be signed same form.",

    subtitle:
      "If the employee had a so-called need-based employment, that is, over a longer period of time, several short-term employments (for example, so-called 'temporary temporary work'), these can be filled in on the same certificate.",
    sub_description1:
      "Position (employed as): Enter title and/or duties during the last period.",
    sub_description2:
      "If the employment has not ended, tick 'Still employed' Then leave the 'to m box' empty. You should not fill in a date that is in the future, even if it is a fixed-term employment and thus has a future end date.",
    other_des:
      "If leave of absence occurs/occurred, the time period and scope are indicated.",
  },
  {
    title: "3 Form of employment",
    description:
      "State whether the employment was permanent employment, temporary employment or probationary employment. In the case of trial employment and limited-term employment, the period of employment according to the original agreement must be specified.",
    subtitle:
      "If the employment period was dependent on a certain assignment or a certain work task, enter temporary employment. If the work has ended because the task, or task, has been completed, enter the date on which it was completed as 'Agreed end date'.",
  },
  {
    title: "4 Working",
    description:
      "Enter one of the options full-time, part-time or variable working hours. For fixed working hours, you must both tick the box and enter the working hours per week. In the case of part-time employment with fixed working hours, both the working hours per week and the extent of the position in percentage must be stated. You always fill in this way if the employee has a fixed length of service, even if the working time can actually vary between different weeks, for example because it is scheduled.",
    subtitle: "Another reason",
    sub_description1:
      "If the work has ceased for any reason other than those stated above, state the reason here.",
  },
  {
    title: "6 Compensation due to termination of employment",
    description:
      "Mark here if an agreement on severance pay or other compensation has been entered into due to termination of employment. This does not apply to already earned benefits, such as vacation pay or unpaid wages, which were paid out because the employment ended.",
  },
  {
    title: "7 Offer of continued work",
    description:
      "If the employee has been offered work, state the type of employment and the scope. Do not forget to indicate whether the employee has accepted or not. If the employee has not accepted an offer, enter the date the employee declined the offer.",
    subtitle:
      "Minutes are given in hundredths of an hour, eg 37 hours and 45 minutes are written as 37.75.",
  },
  {
    title: "9 Signature",
    description:
      "The certificate must be signed by the employer (or the employer's representative) on both sides.",
  },
  {
    title: "10 Social security number",
    description: "Enter your social security number on page 2 as well.",
  },
  {
    title: "11 Time worked",
    description:
      "Enter the time period to which the reported time refers. Enter how many hours the employee worked during the last twelve months of employment. If the employee has had a break in work, for example due to illness, education, parental leave, full military service or other reasons, the task must be extended in time so that at least twelve months of work is reported (if the employment lasted that long).",
    subtitle: "Always specify the work month by month.",
  },
  {
    title: "Hours worked",
    description:
      "Overtime, additional time and filling time must not be included in the column for hours worked Mar.",
    subtitle: "Leave with retained pay counts as work",
    sub_description1:
      "For those who have fixed working hours and receive a monthly salary, work-free 'red days' and 'squeeze days' are counted as work, if salary deductions are not made for the leave.",
    sub_description2:
      "Time when the employee received notice pay, holiday pay, weekend pay, waiting time compensation, layoff pay or compensation for seafarers must be counted as time worked. Holiday pay in connection with termination of employment shall not be included in time worked. Absence due to illness, the birth of a child or compulsory military service must not be entered  as time worked, even if the employee is entitled to sick pay or 'fill-in' during this time.",
    other_des:
      "Time on call, standby time, waiting time, travel time and waste time must not be entered on the form 'Employer's certificate'. Such time must be specified on the 'Supplementing to Employer Certificate'. The number of hours and how much compensation the employee received per month for such time is stated on the 'Complementary to Employer's Certificate'.",
  },
  {
    title: "Absence",
    description:
      "The absence is given in hours. Absence must only be entered for those who have agreed working hours. The number of hours in the column for 'worked time' and in the column for 'absence' per month must correspond to the agreed working hours per month.",
    subtitle:
      "Enter the number of hours the employee was absent with salary deductions. The reason for the absence does not matter.",
    sub_description1:
      "Absence due to illness, the birth of a child or compulsory military service must be entered as absence, even if the employee is entitled to sick pay or 'fill-in' during this time.",
    sub_description2:
      "Time with sick pay is reported on 'Supplementing to Employer's Certificate'.",
    other_des:
      "If the employee is on leave with retained salary, for example paid holiday (during the period of employment), 'red days' or squeeze days, they should not be counted as absence - this leave is counted as worked time.",
  },
];

export const empCertificateRight = [
  {
    description:
      "If the working hours have not been determined, enter variable working hours. For example, when the employee has had several short-term employments over a longer period of time, for example in intermittent employments, temporary employments or the like.",
  },
  {
    title: "Fixed working hours with hourly pay",
    description:
      "Please note that it is the agreed working hours that must be entered in this field. The salary is stated later under point 12.",
  },
  {
    title: "Several different weekly working hours",
    description:
      "During employment, has the employee had periods of different weekly working hours, e.g. periodically worked 30 hours/week and periodically 20 hours/week, an employer's certificate must be issued per employment level. This also applies if the employee sometimes had variable and sometimes fixed working hours. Then write a certificate for each period.",
    subtitle:
      "Minutes are given in hundredths of an hour, eg 37 hours and 45 minutes are written as 37.75.",
  },
  {
    title: "4 Special information about the employment",
    description:
      "Companies with personnel leasing operations and so-called staffing companies must provide information here if the employee has been employed to be hired out.",
  },
  {
    title: "5 Reason why the employment has ended in whole or in part",
    description:
      "Termination by the employer: State the reason why the employee was terminated. Also state when the employee was notified of the dismissal.",
    subtitle:
      "End-term appointment: This alternative to the appointment is time-limited and terminates at the time agreed upon. And also when the employee was informed that the work would not continue. after the agreed final date.",
    sub_description2:
      "If the employment was limited in time but ended prematurely, one of the other options 'Termination by the employer', 'The employee's own request' or 'other reason' is indicated.",
    other_des:
      "The employee's own request: Enter here if the employee resigned himself/herself. Here you also mark whether the employment has been terminated by an agreement between the employer and the employee.",
  },
  {
    title: "Time with sick pay",
    description:
      "Sick leave that is compensated with sick pay according to the Act (1991:1047) on sick pay (the first 14 days of sick pay) must be reported partly as absence on the main form 'Employer's certificate' and partly as Other compensation on the 'Supplement to Employer's certificate'.",
    subtitle:
      "Leave of absence (before 1 January 2019) has not been replaced with sick pay and must therefore only be reported as absence on the 'Employer's certificate'.",
    sub_description1:
      "The days that are compensated by Försäkringskassan must only be reported as absence on the 'Employer's certificate'.",
    sub_description2:
      "Sickness pay is reported for each calendar month in which it has been paid on 'Complementing to Employer's certificate'. Use the column for 'Other remuneration'. You state that it is sick pay and the number of hours with sick pay in the 'Enter type' field. You enter earned sick pay in the field 'Kr/month'.",
  },
  {
    title: "11 Information about the salary",
    description:
      "The information must refer to the salary that the employee had when the employment ended. If the applicant has received a salary revision after he stopped working (for example during parental leave), the salary after the latest salary revision must be stated. Indicate the year to which the information provided refers.",
    subtitle:
      "Enter only one option from the options hourly wage, daily wage, weekly wage or monthly wage",
    sub_description1:
      "Overtime/overtime: Details of pay for overtime and overtime/filling time must only be entered if there is such work. If the pay for overtime and overtime/fill-in time has not varied, the hourly pay is stated on the employer's certificate. If the salary has varied, the salary must be reported on 'Supplementing to employer's certificate. The working hours must always be stated on the employer's certificate.",
    sub_description2:
      "The salary must be stated excluding holiday pay. Paid vacation pay and vacation allowance must be reported on the 'Complementary to Employer Certificate' during the month it was paid. Holiday pay paid in cash and holiday allowance in connection with termination of employment must be reported in the last month of employment.",
    other_des:
      "On-call etc.: On-call, readiness, waiting time, travel time and waste time are specified on the 'Supplement to Employer Certificate', both regarding time and salary.",
  },
  {
    title: "Commission salary",
    description:
      "The commission part of the salary is specified on the form 'Completion to employer's certificate'. On 'Completion to employer's certificate' the total commission sum per month for the same months as specified on the 'Employer's certificate' form is entered. The working hours and basic salary are recorded on the form 'Employer's certificate'. If the employee has had no basic salary, this is stated under 'Other information' on the 'Employer certificate' form.",
    subtitle:
      "Wage, salary per assignment or similar: The salary is specified on the form 'completion to employer's certificate'. If the time worked is known, it is specified on the form 'Employer's certificate'. If the time worked is not known, this is stated under 'Other information' on the 'Employer certificate' form.",
    sub_description1:
      "Remuneration other than salary: Remuneration other than salary that is taxed as income from service is specified on the form 'Complementing to employer's certificate'. For example, it could be car or mileage compensation, which is taxed as income from services.",
    sub_description2:
      "Variable allowances: Variable allowances, for example on-call and OB allowance, must be entered on the form 'Complementing employer's certificate'.",
  },
  {
    title: "13 Residency pay and holiday pay",
    description:
      "Employment in an activity linked to the school year: State whether the employee had a position with holiday pay, holiday pay or subsistence pay. When the employee is entitled to subsistence wages, the amount of money the employee is entitled to in subsistence wages is stated",
  },
  {
    title: "13 Other information",
    description:
      "Here you can provide additional information if you think it is necessary. If there is not enough space, you can write on a separate piece of paper. Then don't forget to write the employee's social security number on the paper, since the unemployment fund registers cases based on social security number.",
  },
  {
    title: "15 Employer and signature",
    description: "Enter contact details and phone number.",
  },
];

export const taxIncomeService = [
  {
    monthdate: "",
    numberOfDaysWorked: "",
    dutyHours: "",
    nOKMonth: "",
    otherRemunerationEnterArt: "",
    nOKMonthAmount: "",
  },
  {
    monthdate: "",
    numberOfDaysWorked: "",
    dutyHours: "",
    nOKMonth: "",
    otherRemunerationEnterArt: "",
    nOKMonthAmount: "",
  },
  {
    monthdate: "",
    numberOfDaysWorked: "",
    dutyHours: "",
    nOKMonth: "",
    otherRemunerationEnterArt: "",
    nOKMonthAmount: "",
  },
  {
    monthdate: "",
    numberOfDaysWorked: "",
    dutyHours: "",
    nOKMonth: "",
    otherRemunerationEnterArt: "",
    nOKMonthAmount: "",
  },
  {
    monthdate: "",
    numberOfDaysWorked: "",
    dutyHours: "",
    nOKMonth: "",
    otherRemunerationEnterArt: "",
    nOKMonthAmount: "",
  },
  {
    monthdate: "",
    numberOfDaysWorked: "",
    dutyHours: "",
    nOKMonth: "",
    otherRemunerationEnterArt: "",
    nOKMonthAmount: "",
  },
  {
    monthdate: "",
    numberOfDaysWorked: "",
    dutyHours: "",
    nOKMonth: "",
    otherRemunerationEnterArt: "",
    nOKMonthAmount: "",
  },
  {
    monthdate: "",
    numberOfDaysWorked: "",
    dutyHours: "",
    nOKMonth: "",
    otherRemunerationEnterArt: "",
    nOKMonthAmount: "",
  },
  {
    monthdate: "",
    numberOfDaysWorked: "",
    dutyHours: "",
    nOKMonth: "",
    otherRemunerationEnterArt: "",
    nOKMonthAmount: "",
  },
  {
    monthdate: "",
    numberOfDaysWorked: "",
    dutyHours: "",
    nOKMonth: "",
    otherRemunerationEnterArt: "",
    nOKMonthAmount: "",
  },
  {
    monthdate: "",
    numberOfDaysWorked: "",
    dutyHours: "",
    nOKMonth: "",
    otherRemunerationEnterArt: "",
    nOKMonthAmount: "",
  },
  {
    monthdate: "",
    numberOfDaysWorked: "",
    dutyHours: "",
    nOKMonth: "",
    otherRemunerationEnterArt: "",
    nOKMonthAmount: "",
  },
  {
    monthdate: "",
    numberOfDaysWorked: "",
    dutyHours: "",
    nOKMonth: "",
    otherRemunerationEnterArt: "",
    nOKMonthAmount: "",
  },
];

export const whatsLaunched = [
  {
    id: 1,
    title: "View Detailed Amounts for Each Freelancer",
    desc: "Users can now view the amount associated with each freelancer, in addition to the total amount.",
  },
  {
    id: 2,
    title: "Invoicing in Preferred Language",
    desc: "You can now issue invoices in your customer's preferred language, enhancing convenience and communication.",
  },
  {
    id: 3,
    title: "Holiday pay amount with transaction history",
    desc: "Track your holiday pay and view transaction history with ease in our new user interface. You can now filter data according to your specific needs, enhancing your control over your holiday pay information.",
  },
  {
    id: 4,
    title: "Pension amount with transaction history",
    desc: "View your pension amount and transaction history conveniently in our updated user interface. You now have the ability to filter transactions according to your preferences, providing enhanced visibility and management of your pension information.",
  },
  {
    id: 5,
    title: "Get Your Salary Faster: Payments in 24 Hours!",
    desc: "We're excited to announce major upgrades to our payment and invoicing systems designed to get you paid quicker and streamline your financial tasks! You'll now receive salary payments within 24 hours instead of 48. We've also automated payment reminders and credit notes, ensuring smoother financial operations. Plus, our invoicing tool now provides a more detailed calculation breakdown and directly integrates mileage and per diem reporting for easier expense tracking.",
  },

];

export const vatFormats = {
  BE: { regex: /^\d{10}$/, minLength: 10, maxLength: 10, exampleFormat: "BE 0123456789", vatPlaceholder: "9999999999" },
  AD: { regex: /^\d{10}$/, minLength: 6, maxLength: 6, exampleFormat: "AD 123456", vatPlaceholder: "999999" },
  BG: { regex: /^\d{9,10}$/, minLength: 9, maxLength: 10, exampleFormat: "BG 123456789 or BG 1234567890", vatPlaceholder: "9999999999" },
  LB: { regex: /^\d{9,10}$/, minLength: 8, maxLength: 8, exampleFormat: "LB 12345678", vatPlaceholder: "99999999" },
  DK: { regex: /^\d{8}$/, minLength: 8, maxLength: 8, exampleFormat: "DK 12345678", vatPlaceholder: "99999999" },
  EE: { regex: /^\d{9}$/, minLength: 9, maxLength: 9, exampleFormat: "EE 123456789", vatPlaceholder: "999999999" },
  FI: { regex: /^\d{8}$/, minLength: 8, maxLength: 8, exampleFormat: "FI 12345678", vatPlaceholder: "99999999" },
  ZW: { regex: /^\d{8}$/, minLength: 8, maxLength: 8, exampleFormat: "ZW 12345678", vatPlaceholder: "99999999" },
  FR: { regex: /^[0-9A-HJ-NP-Z]?[0-9A-HJ-NP-Z]?\d{9}$/, minLength: 11, maxLength: 11, exampleFormat: "FR 12345678901", vatPlaceholder: "99999999999" },
  EL: { regex: /^\d{9}$/, minLength: 9, maxLength: 9, exampleFormat: "EL 123456789", vatPlaceholder: "999999999" },
  IT: { regex: /^\d{11}$/, minLength: 11, maxLength: 11, exampleFormat: "IT 12345678901", vatPlaceholder: "99999999999" },
  HR: { regex: /^\d{11}$/, minLength: 11, maxLength: 11, exampleFormat: "HR 12345678901", vatPlaceholder: "99999999999" },
  LV: { regex: /^\d{11}$/, minLength: 11, maxLength: 11, exampleFormat: "LV 12345678901", vatPlaceholder: "99999999999" },
  LT: { regex: /^\d{9,12}$/, minLength: 9, maxLength: 12, exampleFormat: "LT 123456789 or LT 123456789012", vatPlaceholder: "999999999999" },
  LU: { regex: /^\d{8}$/, minLength: 8, maxLength: 8, exampleFormat: "LU 12345678", vatPlaceholder: "99999999" },
  MT: { regex: /^\d{8}$/, minLength: 8, maxLength: 8, exampleFormat: "MT 12345678", vatPlaceholder: "99999999" },
  NL: { regex: /^\d{9}[bB]\d{2}$/, minLength: 12, maxLength: 12, exampleFormat: "NL 123456789B01", vatPlaceholder: "999999999B99" },
  XI: { regex: /^(\d{9}|\d{12}|GD\d{3}|HA\d{3})$/, minLength: 5, maxLength: 12, exampleFormat: "XI 123456789 or XI GD123", vatPlaceholder: "999999999999" },
  PL: { regex: /^\d{10}$/, minLength: 10, maxLength: 10, exampleFormat: "PL 1234567890", vatPlaceholder: "9999999999" },
  PT: { regex: /^\d{9}$/, minLength: 9, maxLength: 9, exampleFormat: "PT 123456789", vatPlaceholder: "999999999" },
  RO: { regex: /^\d{2,10}$/, minLength: 2, maxLength: 10, exampleFormat: "RO 12 or RO 1234567890", vatPlaceholder: "9999999999" },
  SK: { regex: /^\d{10}$/, minLength: 10, maxLength: 10, exampleFormat: "SK 1234567890", vatPlaceholder: "9999999999" },
  SI: { regex: /^\d{8}$/, minLength: 8, maxLength: 8, exampleFormat: "SI 12345678", vatPlaceholder: "99999999" },
  GB: { regex: /^(\d{9}|\d{12}|GD\d{3}|HA\d{3})$/, minLength: 5, maxLength: 12, exampleFormat: "GB 123456789 or GB GD123", vatPlaceholder: "999999999999" },
  SE: { regex: /^\d{12}$/, minLength: 12, maxLength: 12, exampleFormat: "SE 123456789012", vatPlaceholder: "999999999999" },
  CZ: { regex: /^\d{8,10}$/, minLength: 8, maxLength: 10, exampleFormat: "CZ 12345678 or CZ 1234567890", vatPlaceholder: "9999999999" },
  DE: { regex: /^\d{9}$/, minLength: 9, maxLength: 9, exampleFormat: "DE 123456789", vatPlaceholder: "999999999" },
  HU: { regex: /^\d{8}$/, minLength: 8, maxLength: 8, exampleFormat: "HU 12345678", vatPlaceholder: "99999999" },
  AT: { regex: /^U\d{8}$/, minLength: 9, maxLength: 9, exampleFormat: "AT U12345678", vatPlaceholder: "U99999999" },
  CY: { regex: /^\d{8}[a-zA-Z]$/, minLength: 9, maxLength: 9, exampleFormat: "CY 12345678X", vatPlaceholder: "99999999X" },
  IE: { regex: /^\d[a-zA-Z0-9]\d{5,6}[a-zA-Z]{1,2}$/, minLength: 8, maxLength: 10, exampleFormat: "IE 3A46140B, IE 3746140HH", vatPlaceholder: "9X9999XX" },
  ES: { regex: /^[A-Z0-9]\d{7}[A-Z0-9]$/, minLength: 9, maxLength: 9, exampleFormat: "ES B1234567X or ES B44896082", vatPlaceholder: "X9999999X" }
};

// EU-27 member states — the only country codes for which the VAT validation API is called
export const europeanVatCountryCodes = new Set([
    'AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'EL', 'ES',
    'FI', 'FR', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT',
    'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK',
]);
